<section class="modal-window">
    <header>
        <h3></h3>
    </header>
    <div class="mw-body">
    </div>

    <footer mat-dialog-actions>
        <button mat-raised-button color='primary' (click)="close()"><span i18n>Continue</span></button>
    </footer>

</section>
